/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { ExtensibleNode } from '../../core/models/ExtensibleNode';
import { INamed } from '../../core/models/common/INamed';
import { IVisitor } from '../../core/visitors/IVisitor';
import { IOasVisitor } from '../visitors/IOasVisitor';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends ExtensibleNode
 * @author eric.wittmann@gmail.com
 */
export class OasHeader extends ExtensibleNode implements INamed {
    /*private*/ _name : string;

    public description : string;

    public constructor(name : string) {
        super();
        if(this._name===undefined) this._name = null;
        if(this.description===undefined) this.description = null;
        this._name = name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOasVisitor = <IOasVisitor><any>visitor;
        viz.visitHeader(this);
    }
}
OasHeader["__class"] = "io.apicurio.datamodels.openapi.models.OasHeader";
OasHeader["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.common.INamed"];




